const url = 'https://kind-pink-anemone-tutu.cyclic.app/getDetailsByType/'

function getProuduct(type, setData, setError, setLoading) {
    fetch(`${url}${type}`).then(response => {
        if (response.ok) {
            return response.json()
        }
        throw response
    }).then(data => {
        setData(data.products)
    }).catch(error => {
        setError(error)
    }).finally(() => {
        setLoading(false)
    })
}

export default getProuduct